import { useState, useCallback, useEffect } from "react";
import { request } from "../../httpClient";

export const useVehicleTypeList = () => {
  const [vehicleTypeListLoading, setVehicleTypeListLoading] = useState(false);
  const [vehicleTypeList, setVehicleTypeList] = useState([]);

  const getVehicleTypeList = useCallback(async () => {
    setVehicleTypeListLoading(true);
    const res = await request({
      path: "vehicle-type/list",
    });
    setVehicleTypeList(res?.data);
    setVehicleTypeListLoading(false);
    return res?.data;
  }, []);

  useEffect(() => {
    getVehicleTypeList();
  }, []);

  return { vehicleTypeListLoading, vehicleTypeList, getVehicleTypeList };
};
